(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Settings.Agency.User.Contracting",
                {
                    url: "/Contracting",
                    component: "contracting",
                    resolve: {
                    },
                    data: {
                        pageTitle: "Contracting"
                    },
                    onEnter: ["$state", "person", function ($state, person) {
                        if (!person) {
                            $state.go("Home.404");
                        }
                    }]
                });
        }
    ]);

    app.component("contracting",
        {
            templateUrl: "/App/Settings/Agency/User/Contracting/contracting-template.html",
            controller: contractingController,
            bindings: {
                user: "<",
                person: "<"
            }
        });

    contractingController.$inject = ["externalArcContractReportApi", "$q"];
    function contractingController(externalArcContractReportApi, $q) {
        var $ctrl = this;
        $ctrl.Contracts = [];

       

        ng.extend($ctrl,
            {
                ui: {
                    loading: true
                },
                addContractDetails: addContractDetails,
                Contracts: []
            });

        function addContractDetails(contract) {
            return externalArcContractReportApi.getContractDetail($ctrl.user.Id, contract.ContractGuid).then(function (response) {
                contract.details = response;
            });
        }

        $ctrl.$onInit = () => {
            externalArcContractReportApi.getUserContracts($ctrl.user.Id).then(function (response) {
                $ctrl.Contracts = response;
                var promises = [];
                ng.forEach($ctrl.Contracts,
                    function (row) {
                        promises.push(addContractDetails(row));
                    });
                $q.all(promises).then(function () {
                    $ctrl.ui.loading = false;
                });
            });
        }
    }

})(window.app, window.angular); //jshint ignore:line